import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useState } from 'react';
export function useSearchValue() {
  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      searchValue = _useState2[0],
      setSearchValue = _useState2[1];

  var handleSearchFieldChange = useCallback(function (_event, value) {
    return setSearchValue(value);
  }, []);
  return [searchValue, handleSearchFieldChange];
}